(function(){
  var CSS = ".lm-qb-variants{display:none;margin-top:14px;padding-top:12px;border-top:1px solid rgba(0,0,0,.14);}\n  .lm-qb-title{font-size:1.15rem;font-weight:600;text-transform:uppercase;letter-spacing:.05em;margin:0 0 10px;opacity:.7;}\n  .lm-qb-pair{display:flex;flex-wrap:wrap;align-items:center;gap:5px;margin-bottom:8px;}\n  .lm-qb-pair:last-child{margin-bottom:0;}\n  .lm-qb-num{flex:0 0 auto;font-size:1.25rem;font-weight:600;min-width:40px;white-space:nowrap;}\n  .lm-qb-swatches{display:flex;flex-wrap:nowrap;gap:4px;flex:1 1 120px;min-width:0;padding:3px 0;}\n  .lm-qb-sw{flex:1 1 0;min-width:14px;max-width:26px;height:22px;border-radius:50%;border:1px solid rgba(0,0,0,.25);padding:0;margin:0;cursor:pointer;background-color:#eee;background-size:cover;background-position:center;background-repeat:no-repeat;box-shadow:none;transition:box-shadow .15s ease;}\n  @supports (aspect-ratio:1/1){.lm-qb-sw{height:auto;aspect-ratio:1/1;}}\n  .lm-qb-sw.is-selected{box-shadow:0 0 0 1px #fff,0 0 0 3px #000;}\n  .lm-qb-sw[disabled]{opacity:.28;cursor:not-allowed;}\n  .lm-qb-size{flex:0 0 64px;min-height:36px;padding:6px 26px 6px 9px;font-size:1.3rem;font-family:inherit;color:inherit;line-height:1.2;border:1px solid rgba(0,0,0,.35);border-radius:4px;background-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23000' stroke-width='1.6'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:right 9px center;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;}\n  .lm-qb-size:focus,.lm-qb-sw:focus-visible{outline:2px solid rgba(0,0,0,.6);outline-offset:1px;}\n  .lm-sticky-price{display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;}\n  .lm-sticky-price__was{opacity:.55;font-weight:400;text-decoration:line-through;}\n  .lm-sticky-variant .sticky-atc-active-variant__option{display:block;}\n  .quantity-breaks-container label.quantity-break::before{top:var(--lm-radio-top,50%) !important;}";
  if (!document.getElementById('lm-qb-style')) {
    var st = document.createElement('style');
    st.id = 'lm-qb-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  var el = document.getElementById('lm-qb-data');
  if (!el) return;
  var DATA;
  try { DATA = JSON.parse(el.textContent); } catch (e) { return; }
  if (!DATA || !DATA.variants || !DATA.variants.length) return;

  var SI = DATA.sizePos - 1;
  var CI = DATA.colorPos > 0 ? DATA.colorPos - 1 : -1;

  var wrap = null;
  var sw1 = null, s1 = null, sw2 = null, s2 = null;
  var lastId = null, lastItems = null, rebuilt = false;
  var state1 = { color: null, size: null };
  var state2 = { color: null, size: null };

  function q2(){ return document.getElementById('quantity2'); }

  function form(){
    var r = q2();
    if (r && r.form) return r.form;
    var pf = document.querySelector('product-form');
    return pf ? pf.querySelector('form') : null;
  }

  function idInput(){
    var f = form();
    return f ? f.querySelector('input[name="id"]') : null;
  }

  function currentVariant(){
    var inp = idInput();
    if (!inp || !inp.value) return null;
    var id = String(inp.value).split(',')[0];
    for (var i = 0; i < DATA.variants.length; i++){
      if (String(DATA.variants[i].id) === id) return DATA.variants[i];
    }
    return null;
  }

  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function attrEsc(s){ return String(s).replace(/"/g,'\\"'); }

  function colorList(){
    var out = [], seen = {};
    if (CI < 0) return out;
    for (var i = 0; i < DATA.variants.length; i++){
      var v = DATA.variants[i], c = v.options[CI];
      if (!(c in seen)){ seen[c] = out.length; out.push({ value: c, available: !!v.available }); }
      else if (v.available) out[seen[c]].available = true;
    }
    return out;
  }

  function sizeList(color){
    var out = [], seen = {};
    for (var i = 0; i < DATA.variants.length; i++){
      var v = DATA.variants[i];
      if (CI >= 0 && color != null && v.options[CI] !== color) continue;
      var s = v.options[SI];
      if (seen[s]) continue;
      seen[s] = 1;
      out.push({ value: s, available: !!v.available });
    }
    return out;
  }

  function findVariant(color, size){
    for (var i = 0; i < DATA.variants.length; i++){
      var v = DATA.variants[i];
      if (CI >= 0 && v.options[CI] !== color) continue;
      if (v.options[SI] !== size) continue;
      return v;
    }
    return null;
  }

  // Reuse the real swatch appearance from the theme's own colour picker so the
  // bundle swatches can never drift from the ones above them.
  function mainSwatch(colorValue){
    var r = document.querySelector('variant-radios input[name="' + attrEsc(DATA.colorName) + '"][value="' + attrEsc(colorValue) + '"]');
    if (!r) return null;
    var lab = (r.id ? document.querySelector('label[for="' + r.id + '"]') : null) || r.nextElementSibling;
    if (!lab || lab.tagName !== 'LABEL') return null;
    var cs = window.getComputedStyle(lab);
    return { image: cs.backgroundImage, color: cs.backgroundColor };
  }

  function paintSwatches(box, selected){
    if (!box) return;
    var list = colorList(), i;
    if (box.childNodes.length !== list.length){
      var html = '';
      for (i = 0; i < list.length; i++){
        html += '<button type="button" class="lm-qb-sw" data-value="' + esc(list[i].value) + '" title="' + esc(list[i].value) + '" aria-label="' + esc(list[i].value) + '"></button>';
      }
      box.innerHTML = html;
    }
    var btns = box.querySelectorAll('.lm-qb-sw');
    for (i = 0; i < btns.length && i < list.length; i++){
      var b = btns[i], it = list[i];
      var look = mainSwatch(it.value);
      if (look){
        if (b.style.backgroundImage !== look.image) b.style.backgroundImage = look.image;
        if (b.style.backgroundColor !== look.color) b.style.backgroundColor = look.color;
      }
      if (b.disabled !== !it.available) b.disabled = !it.available;
      var on = (it.value === selected);
      if (b.classList.contains('is-selected') !== on) b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function paintSizes(sel, color, keep){
    var list = sizeList(color), html = '', i;
    for (i = 0; i < list.length; i++){
      var it = list[i];
      html += '<option value="' + esc(it.value) + '"' + (it.available ? '' : ' disabled') + '>' +
              esc(it.value) + (it.available ? '' : ' — Sold out') + '</option>';
    }
    if (sel.innerHTML !== html) sel.innerHTML = html;
    if (keep != null){
      for (i = 0; i < sel.options.length; i++){
        if (sel.options[i].value === keep && !sel.options[i].disabled){ sel.selectedIndex = i; return sel.value; }
      }
    }
    for (i = 0; i < sel.options.length; i++){
      if (!sel.options[i].disabled){ sel.selectedIndex = i; return sel.value; }
    }
    return sel.value;
  }

  function pairMarkup(n){
    return '<div class="lm-qb-pair"><span class="lm-qb-num">Pair ' + n + '</span>' +
      (CI >= 0 ? '<div class="lm-qb-swatches" data-pair="' + n + '"></div>' : '') +
      '<select class="lm-qb-size" data-pair="' + n + '" aria-label="Size for pair ' + n + '"></select></div>';
  }

  // The tier row reserves ~48px on the left for its radio circle. Below the tier
  // content that gutter is dead space, so pull the block out into it — that is
  // what keeps all 8 swatches on one line on a phone.
  function reclaimWidth(){
    if (!wrap || !wrap.parentNode) return;
    var cs = window.getComputedStyle(wrap.parentNode);
    var inset = 6;
    var pl = parseFloat(cs.paddingLeft) || 0;
    var pr = parseFloat(cs.paddingRight) || 0;
    var ml = pl > inset ? (-(pl - inset) + 'px') : '0px';
    var mr = pr > inset ? (-(pr - inset) + 'px') : '0px';
    if (wrap.style.marginLeft !== ml) wrap.style.marginLeft = ml;
    if (wrap.style.marginRight !== mr) wrap.style.marginRight = mr;
  }

  // Our block makes the tier row taller, which would drag the theme's vertically
  // centred radio circle down on top of it. Pin it to the tier content instead.
  function alignRadio(){
    if (!wrap || !wrap.parentNode) return;
    var lab = wrap.parentNode;
    var c = lab.querySelector('.quantity-break__content');
    if (!c) return;
    var lr = lab.getBoundingClientRect(), cr = c.getBoundingClientRect();
    if (!lr.height || !cr.height) return;
    var val = Math.round(cr.top - lr.top + cr.height / 2) + 'px';
    if (lab.style.getPropertyValue('--lm-radio-top') !== val){
      lab.style.setProperty('--lm-radio-top', val);
    }
  }

  function build(){
    var lbl = document.querySelector('label[for="quantity2"]');
    if (!lbl) return false;
    if (wrap && lbl.contains(wrap) && document.body.contains(wrap)) return true;

    wrap = document.createElement('div');
    wrap.className = 'lm-qb-variants';
    wrap.innerHTML = '<div class="lm-qb-title">Choose each pair</div>' + pairMarkup(1) + pairMarkup(2);
    lbl.appendChild(wrap);
    reclaimWidth();
    alignRadio();

    sw1 = wrap.querySelector('.lm-qb-swatches[data-pair="1"]');
    s1  = wrap.querySelector('.lm-qb-size[data-pair="1"]');
    sw2 = wrap.querySelector('.lm-qb-swatches[data-pair="2"]');
    s2  = wrap.querySelector('.lm-qb-size[data-pair="2"]');

    wrap.addEventListener('click', function(e){ e.stopPropagation(); });

    if (sw1) sw1.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('.lm-qb-sw') : null;
      if (!b || b.disabled) return;
      e.preventDefault(); e.stopPropagation();
      setMainOption(DATA.colorName, b.getAttribute('data-value'));
    });
    s1.addEventListener('change', function(e){
      e.stopPropagation();
      setMainOption(DATA.sizeName, s1.value);
    });

    if (sw2) sw2.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('.lm-qb-sw') : null;
      if (!b || b.disabled) return;
      e.preventDefault(); e.stopPropagation();
      state2.color = b.getAttribute('data-value');
      state2.size = paintSizes(s2, state2.color, state2.size);
      paintSwatches(sw2, state2.color);
      updateItems(); updateSticky();
    });
    s2.addEventListener('change', function(e){
      e.stopPropagation();
      state2.size = s2.value;
      updateItems(); updateSticky();
    });

    rebuilt = true;
    return true;
  }

  function setMainOption(name, value){
    var i, k;
    var radios = document.querySelectorAll('variant-radios input[type="radio"][name="' + attrEsc(name) + '"]');
    for (i = 0; i < radios.length; i++){
      if (radios[i].value === value){
        if (!radios[i].checked) radios[i].click();
        return true;
      }
    }
    var sels = document.querySelectorAll('variant-selects select[name="' + attrEsc(name) + '"]');
    for (i = 0; i < sels.length; i++){
      for (k = 0; k < sels[i].options.length; k++){
        if (sels[i].options[k].value === value){
          sels[i].selectedIndex = k;
          sels[i].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function pick(state){
    if (!state.size) return null;
    var v = findVariant(state.color, state.size);
    return v ? { color: state.color, size: state.size, id: v.id } : null;
  }

  function pairLabel(p){
    return p ? ((p.color ? p.color + ' ' : '') + p.size) : '';
  }

  function updateItems(){
    var f = form();
    if (!f) return;
    var holder = f.querySelector('.product-form__multiple-variant-ids');
    if (!holder){
      holder = document.createElement('div');
      holder.className = 'product-form__multiple-variant-ids';
      holder.style.display = 'none';
      f.appendChild(holder);
    }
    var r = q2();
    var p1 = pick(state1), p2 = pick(state2);
    var want = '';
    if (r && r.checked && p1 && p2){
      want =
        '<input type="hidden" name="items[0][id]" value="' + p1.id + '">' +
        '<input type="hidden" name="items[0][quantity]" value="1">' +
        '<input type="hidden" name="items[1][id]" value="' + p2.id + '">' +
        '<input type="hidden" name="items[1][quantity]" value="1">';
    }
    if (want !== lastItems || holder.innerHTML !== want){
      holder.innerHTML = want;
      lastItems = want;
    }
  }

  // The sticky add-to-cart bar mirrors the single selected variant, so in bundle
  // mode it reads as "one pair". Swap in a bundle summary + the tier's own price.
  function updateSticky(){
    var bar = document.querySelector('.sticky-atc');
    if (!bar) return;
    var r = q2();
    var p1 = pick(state1), p2 = pick(state2);
    var active = !!(r && r.checked && p1 && p2);
    var i, j;

    var vs = bar.querySelectorAll('.sticky-atc-active-variant:not(.lm-sticky-variant)');
    for (i = 0; i < vs.length; i++){
      var v = vs[i];
      var mine = v.parentNode.querySelector('.lm-sticky-variant');
      if (active){
        if (!mine){
          mine = document.createElement('div');
          mine.className = 'lm-sticky-variant sticky-atc-active-variant';
          v.parentNode.insertBefore(mine, v.nextSibling);
        }
        var txt = '2 pairs · ' + pairLabel(p1) + ' + ' + pairLabel(p2);
        var h = '<div class="sticky-atc-active-variant__option"><span class="sticky-atc-active-variant__option-value">' + esc(txt) + '</span></div>';
        if (mine.innerHTML !== h) mine.innerHTML = h;
        v.style.display = 'none';
        mine.style.display = '';
      } else {
        v.style.display = '';
        if (mine) mine.style.display = 'none';
      }
    }

    var lbl = document.querySelector('label[for="quantity2"]');
    var bp = lbl ? lbl.querySelector('.quantity-break__price') : null;
    var bc = lbl ? lbl.querySelector('.quantity-break__compare-price') : null;
    var now = bp ? bp.textContent.trim() : '';
    var was = (bc && bc.style.display !== 'none') ? bc.textContent.trim() : '';

    var ps = bar.querySelectorAll('.sticky-atc-price');
    for (j = 0; j < ps.length; j++){
      var p = ps[j];
      var orig = p.querySelector('[id^="price-mobile-"],[id^="price-desktop-"]');
      var mineP = p.querySelector('.lm-sticky-price');
      if (active && now){
        if (!mineP){
          mineP = document.createElement('div');
          mineP.className = 'lm-sticky-price price__container';
          p.appendChild(mineP);
        }
        var ph = '<span class="lm-sticky-price__now">' + esc(now) + '</span>' +
                 (was ? ' <span class="lm-sticky-price__was">' + esc(was) + '</span>' : '');
        if (mineP.innerHTML !== ph) mineP.innerHTML = ph;
        if (orig) orig.style.display = 'none';
        mineP.style.display = '';
      } else {
        if (orig) orig.style.display = '';
        if (mineP) mineP.style.display = 'none';
      }
    }
  }

  function sync(force){
    if (!build()) return;
    var inp = idInput();
    var idNow = inp ? String(inp.value) : '';
    var changed = force || rebuilt || idNow !== lastId;
    rebuilt = false;

    if (changed){
      lastId = idNow;
      var cur = currentVariant();
      state1.color = (cur && CI >= 0) ? cur.options[CI] : null;
      state1.size = cur ? cur.options[SI] : null;

      if (state2.color == null) state2.color = state1.color;
      if (state2.size == null) state2.size = state1.size;

      paintSwatches(sw1, state1.color);
      state1.size = paintSizes(s1, state1.color, state1.size);

      paintSwatches(sw2, state2.color);
      state2.size = paintSizes(s2, state2.color, state2.size);
    } else {
      paintSwatches(sw1, state1.color);
      paintSwatches(sw2, state2.color);
    }

    reclaimWidth();

    var r = q2();
    wrap.style.display = (r && r.checked) ? 'block' : 'none';
    alignRadio();
    updateItems();
    updateSticky();
  }

  if (typeof window.resetIdInputValue !== 'function'){
    window.resetIdInputValue = function(){
      var f = form();
      if (f){
        var h = f.querySelector('.product-form__multiple-variant-ids');
        if (h) { h.innerHTML = ''; lastItems = ''; }
      }
      setTimeout(function(){ sync(false); }, 0);
    };
  }
  if (typeof window.quantityBreakVariantChange !== 'function'){
    window.quantityBreakVariantChange = function(){};
  }

  // Shopify's /cart/add processes BOTH items[] and the top-level id+quantity.
  // When the bundle is active we must keep id/quantity out of the submitted FormData.
  function onSubmitCapture(e){
    var f = form();
    if (!f || e.target !== f) return;
    var r = q2();
    if (!r || !r.checked) return;
    var holder = f.querySelector('.product-form__multiple-variant-ids');
    if (!holder || !holder.innerHTML) return;

    var restore = [];
    var els = Array.prototype.slice.call(f.elements);
    for (var i = 0; i < els.length; i++){
      var el2 = els[i];
      if (el2.disabled) continue;
      if (el2.name !== 'id' && el2.name !== 'quantity') continue;
      if (el2.closest && el2.closest('.product-form__multiple-variant-ids')) continue;
      el2.disabled = true;
      restore.push(el2);
    }
    setTimeout(function(){
      for (var j = 0; j < restore.length; j++) restore[j].disabled = false;
    }, 0);
  }
  document.addEventListener('submit', onSubmitCapture, true);

  function init(){
    sync(true);
    document.addEventListener('change', function(e){
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === 'quantity' || t.name === DATA.sizeName || t.name === DATA.colorName){
        setTimeout(function(){ sync(false); }, 0);
        setTimeout(function(){ sync(false); }, 350);
      }
    }, true);
    setInterval(function(){ sync(false); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
